import { fnDecrypt } from '../../../utils/secret';

/**
 * 获取 localStorage 中用户信息
 */
export function getUserInfo() {
    let oUserInfo = {};
    const sLocalStorage = localStorage.getItem('userinfo');
    if (sLocalStorage) {
        try {
            const decryptedStr = fnDecrypt(sLocalStorage);
            oUserInfo = JSON.parse(decryptedStr);
        } catch (error) {
            oUserInfo = {};
            // 如果解密失败则清除缓存
            localStorage.removeItem('token');
            localStorage.removeItem('userinfo');
        }
    }
    return oUserInfo;
}
